import { SVGComponentProps } from "./utils/Types";

const ConnectionOnIcon = ({
  width = 38,
  height = 38,
  className,
}: SVGComponentProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      className={`text-current ${className}`}
    >
      <rect x="15" y="12" width="2" height="18" fill="currentColor"/>
      <path d="M11.33,18.22a7,7,0,0,1,0-10.44l1.34,1.49a5,5,0,0,0,0,7.46Z" fill="currentColor"/>
      <path d="M20.67,18.22l-1.34-1.49a5,5,0,0,0,0-7.46l1.34-1.49a7,7,0,0,1,0,10.44Z" fill="currentColor"/>
      <path d="M8.4,21.8a11,11,0,0,1,0-17.6L9.6,5.8a9,9,0,0,0,0,14.4Z" fill="currentColor"/>
      <path d="M23.6,21.8l-1.2-1.6a9,9,0,0,0,0-14.4l1.2-1.6a11,11,0,0,1,0,17.6Z" fill="currentColor"/>
      <rect width={width} height={height} fill="transparent" />
    </svg>
  )
}

export default ConnectionOnIcon
